import type { ElementAnimationStyle } from '@adflow/utils';
import { FC } from 'react';

type Props = {
  svgString: string;
  animationStyle?: ElementAnimationStyle;
};

const SVGElement: FC<Props> = ({ svgString = '', animationStyle }) => {
  return (
    <div
      style={
        animationStyle
          ? { transform: animationStyle.transform, opacity: animationStyle.opacity }
          : undefined
      }
      dangerouslySetInnerHTML={{ __html: svgString }}
    />
  );
};

SVGElement.displayName = 'SVGElement';

export default SVGElement;
